import type { RootState } from './store'

export const selectAppContext = (state: RootState) => ({
  themeSettingData: state['@customisation'].data
    .themeSettingData as Customisation.ThemeSettingData,
  isBot: state['@meta'].isBot as boolean,
  meta: state['@meta'].detailMenuSite,
  storeOrder: state['@order'].storeOrder,
  user: state['@user'].user
})
